import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import httpHelper, { Method_TYPE } from "../../../utils/http-helper";
import URL_CONSTANTS from "../../../constants/url-constants";
import { isMemberBlocked } from "utils/member-utils";

const EditServiceModal = ({ member, isOpen, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    servicePoint: '',
    sector: '',
    allocationDate: '',
    serviceDescription: ''
  });
  const [loading, setLoading] = useState(false);

  const [deploymentDetails, setDeploymentDetails] = useState([]);
  const [batchDetails, setBatchDetails] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState("");
  const [selectedDeploymentPoint, setSelectedDeploymentPoint] = useState("");
  const [requiredCount,setRequiredCount] = useState(0);
  const [allocatedCount, setAllocatedCount] = useState(0);
  const [isActionAllowed,setISActionAllowed] = useState(true)

  // Mock data for dropdowns
  const sectors = [
    { value: 'registration', label: 'Registration & Reception' },
    { value: 'kitchen', label: 'Kitchen & Food Service' },
    { value: 'security', label: 'Security & Crowd Management' },
    { value: 'medical', label: 'Medical & First Aid' },
    { value: 'transport', label: 'Transport & Logistics' },
    { value: 'decoration', label: 'Decoration & Stage' },
    { value: 'audio', label: 'Audio & Technical' },
    { value: 'cleaning', label: 'Cleaning & Maintenance' }
  ];

  const servicePoints = [
    { value: 'main-gate', label: 'Main Gate Registration' },
    { value: 'vip-reception', label: 'VIP Reception Desk' },
    { value: 'kitchen-prep', label: 'Kitchen Preparation' },
    { value: 'food-serving', label: 'Food Serving Counter' },
    { value: 'security-entrance', label: 'Security - Entrance' },
    { value: 'crowd-control', label: 'Crowd Control' },
    { value: 'medical-station', label: 'Medical Station' },
    { value: 'first-aid', label: 'First Aid Point' },
    { value: 'parking', label: 'Parking Management' },
    { value: 'transport-coord', label: 'Transport Coordination' }
  ];

  useEffect(() => {
    if (member && isOpen) {
      setFormData({
        servicePoint: member.servicePoint || '',
        sector: member.sector || '',
        allocationDate: member.allocationDate || new Date().toISOString().split('T')[0],
        serviceDescription: member.serviceDescription || ''
      });
      fetchDeploymentPointMeta();
      getCurrentBatch();
    }
  }, [member, isOpen]);

  // useEffect(() => {
  //   fetchDeploymentPointMeta();
  //   getCurrentBatch();
  // }, []);

  const getCurrentBatch = async () => {
    try {
      const data = await httpHelper(
        URL_CONSTANTS.GET_CURRENT_BATCH_DETAILS,
        Method_TYPE.GET
      );
      setSelectedBatch(data?._id || "");
      setBatchDetails(
        data?.period?.batches?.filter(val => val?._id === data?._id).map((val) => ({
          label: val?.name,
          value: val?._id,
        }))
      );
    } catch (err) {
      console.error("Error fetching batch details:", err);
    }
  };

  const fetchDeploymentPointMeta = async () => {
    try {
      const response = await httpHelper(
        `${URL_CONSTANTS.DEPLOYMENT_POINTS}/${member?.id}`,
        Method_TYPE.GET
      );
      setDeploymentDetails(
        response?.map((res) => ({
          label: res?.name,
          value: res?._id,
          sector : res?.sector
        }))
      );
    } catch (err) {
      console.log("Fetch deployment point meta error", err);
    }
  };


  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
   
    setLoading(true);
    if (selectedBatch === "" || selectedDeploymentPoint === "") {
      alert("Please select both batch and deployment point.");
      setLoading(false);
      return;
    }


    if(allocatedCount >= requiredCount){
      alert('Required count has been met.You cannot assign more members to this deployment point.')
      return;
     }
     
    const data = {
      samithi: member?.samithiId,
      member: member.id,
      district: member?.districtId,
      batch: selectedBatch,
      deploymentpoint: selectedDeploymentPoint,
      sector: deploymentDetails.find(x => x.value === selectedDeploymentPoint)?.sector || '',

    }
    try {

      await httpHelper(`${URL_CONSTANTS.SERVICE}${member?.servicePointId}`, Method_TYPE.PUT, data);
      handleBack()
    } catch (err) {

    }
    setLoading(false);
    onClose();
    window.location.reload();
   
  };

  const onChangeDeploymentPoint = async (value) => {
    setLoading(true)
     setSelectedDeploymentPoint(value);
     const deploymentResult = await httpHelper(`${URL_CONSTANTS.DEPLOYMENT_POINTS}/${selectedBatch}`, Method_TYPE.GET);
     const deployment = deploymentResult.filter(dep => dep._id === value);
     setAllocatedCount(deployment[0]?.allocatedCount || 0);
     setRequiredCount(deployment[0]?.reqCount || 0);
     const allocCount = deployment[0]?.allocatedCount || 0;
     const reqCount = deployment[0]?.reqCount || 0;
     setLoading(false)
     setLoading(false)
    //  if(allocCount >= reqCount){
    //   alert('Required count has been met.Please double check before assignment.')
    // }
  }

  if (!isOpen || !member) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 modal-backdrop z-50 flex items-center justify-center p-4">
      <div className="bg-card rounded-lg border border-border shadow-spiritual-md max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
              <Icon name="Edit" size={24} className="text-primary" />
            </div>
            <div>
              <h2 className="font-heading font-semibold text-xl text-foreground">
                Edit Service Allocation
              </h2>
              <p className="text-sm text-muted-foreground">
                Update service assignment for {member.name}
              </p>
            </div>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClose}
            iconName="X"
          />
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          {/* Member Information Display */}
          <div className="bg-muted/30 rounded-lg p-4">
            <h3 className="font-heading font-medium text-foreground mb-3 flex items-center space-x-2">
              <Icon name="User" size={18} className="text-primary" />
              <span>Member Information</span>
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
              <div>
                <span className="text-muted-foreground">Name:</span>
                <p className="font-medium text-foreground">{member.name}</p>
              </div>
              <div>
                <span className="text-muted-foreground">Mobile:</span>
                <p className="font-mono text-foreground">{member.mobNo}</p>
              </div>
              <div>
                <span className="text-muted-foreground">District:</span>
                <p className="text-foreground">{member.district}</p>
              </div>
              <div>
                <span className="text-muted-foreground">Samithi:</span>
                <p className="text-foreground">{member.samithi}</p>
              </div>
              <div>
                <span className="text-muted-foreground">Sai Connect Id:</span>
                <p className="text-foreground">{member.saiOneId}</p>
              </div>
              <div>
                <span className="text-muted-foreground">Status:</span>
                <p>
                  <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold ${
                    isMemberBlocked(member)
                      ? 'bg-red-100 text-red-700 border border-red-300'
                      : 'bg-green-100 text-green-700 border border-green-300'
                  }`}>
                    {isMemberBlocked(member) ? "Blocked" : "Active"}
                  </span>
                </p>
              </div>
            </div>
          </div>

           {/* Current Allocation Info */}
           <div className="bg-warning/5 border border-warning/20 rounded-lg p-4">
            <h4 className="font-heading font-medium text-foreground mb-2 flex items-center space-x-2">
              <Icon name="Info" size={16} className="text-warning" />
              <span>Current Allocation</span>
            </h4>
            <div className="text-sm text-muted-foreground space-y-1">
              <p><strong>Service Point:</strong> {member.servicePoint}</p>
              {/* <p><strong>Allocation Date:</strong> {member.allocationDate}</p> */}
              {member.serviceDescription && (
                <p><strong>Description:</strong> {member.serviceDescription}</p>
              )}
            </div>
          </div>

          {/* Service Allocation Form */}
          <div className="space-y-4">
            <h3 className="font-heading font-medium text-foreground flex items-center space-x-2">
              <Icon name="Briefcase" size={18} className="text-primary" />
              <span>Change current Allocation</span>
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-2x gap-4">
            <Select
                label="Select Batch"
                placeholder="Assign a batch..."
                options={batchDetails}
                value={selectedBatch}
                onChange={(value) => setSelectedBatch(value)}
                required
                searchable
              />

              <Select
                label="Select Deployment Point"
                placeholder="Assign deployment point..."
                options={deploymentDetails}
                value={selectedDeploymentPoint}
                onChange={onChangeDeploymentPoint}
                required
                searchable
              />        
            </div>

            <div className="bg-muted/30 rounded-lg p-4">
            <h3 className="font-heading font-medium text-foreground mb-3 flex items-center space-x-2">
              <Icon name="User" size={18} className="text-primary" />
              <span>Allocation Details</span>
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-lg">
              <div>
                <span className="text-muted-foreground">Required:</span>
                <p className="font-medium text-foreground">{requiredCount}</p>
              </div>
              <div>
                <span className="text-muted-foreground">Allocated:</span>
                <p className="font-mono text-foreground">{allocatedCount}</p>
              </div>
            </div>
          </div>

          </div>

         
        </form>

        {/* Footer */}
        {isActionAllowed &&
        <div className="flex items-center justify-end space-x-3 p-6 border-t border-border">
          <Button
            variant="outline"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            variant="default"
            onClick={handleSubmit}
            loading={loading}
            iconName="Save"
            iconPosition="left"
          >
            Save Changes
          </Button>
        </div>
      }
      </div>
    </div>
  );
};

export default EditServiceModal;